import React, { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import {
  Home,
  EventDetails,
  PaymentSummary,
  MyTickets,
  OrderFailure,
  OrderSuccess,
  OrderSuccessSub,
  MyFavorites,
  RedeemTickets,
} from "./screens";
import PaymentSummaryWrapper from "./screens/PaymentSummaryWrapper";

import { selectUser } from "./store/slice/user";
import { useSelector } from "react-redux";
import DynamicPage from "./screens/DynamicPage";
import EmployeeLogin from "./screens/EmployeeLogin";
import DeleteAccount from "./screens/DeleteAccount";
import About from "./screens/About";
import Pricing from "./screens/Pricing";
import HowItWorks from "./screens/HowItWorks";
import ContactSales from "./screens/ContactSales";
import Terms from "./screens/Terms";
import Privacy from "./screens/Privacy";
import RefundPolicy from "./screens/RefundPolicy";
import ModelsInfluencers from "./screens/ModelsInfluencers";

const AppRoutes = () => {
  const { token, email } = useSelector(selectUser);
  const isEmployee = localStorage.getItem("isEmployee");
  const navigate = useNavigate();
  useEffect(() => {
    if(isEmployee)
    navigate("/redeem-tickets");
  }, [isEmployee]);
  const appRoutes = [
      { path: "/delete-account", element: <DeleteAccount /> },
    !isEmployee && { path: "/", element: <Home /> },
    !isEmployee && {
      path: "/event-details/:id",
      element: <EventDetails />,
    },
    !isEmployee && { path: "/about", element: <About /> },
    !isEmployee && { path: "/pricing", element: <Pricing /> },
    !isEmployee && { path: "/how-it-works", element: <HowItWorks /> },
    !isEmployee && { path: "/contact-sales", element: <ContactSales /> },
    !isEmployee && { path: "/terms-of-service", element: <Terms /> },
    !isEmployee && { path: "/privacy-policy", element: <Privacy /> },
    !isEmployee && { path: "/refund-policy", element: <RefundPolicy /> },
    !isEmployee && { path: "/models-influencers", element: <ModelsInfluencers /> },
    !token && {
      path: "/employee",
      element: <EmployeeLogin />,
      isPrivate: false,
    },
    !isEmployee && {
      path: "/payment-summary",
      element: <PaymentSummaryWrapper />,
      isPrivate: true,
    },
    
    !isEmployee && {
      path: "/my-tickets",
      element: <MyTickets />,
      isPrivate: true,
    },
    !isEmployee && {
      path: "/my-favorites",
      element: <MyFavorites />,
      isPrivate: true,
    },
    !isEmployee && {
      path: "/order-success",
      element: <OrderSuccess />,
      isPrivate: true,
    },
    !isEmployee && {
      path: "/order-success-subscription",
      element: <OrderSuccessSub />,
      isPrivate: true,
    },
    !isEmployee && {
      path: "/order-failure",
      element: <OrderFailure />,
      isPrivate: true,
    },
    !isEmployee && {
      path: "/:page_slug",
      element: <DynamicPage />,
    },
    isEmployee && {
      path: "/redeem-tickets",
      element: <RedeemTickets />,
    },
  ];

  return (
    <Routes>
      {appRoutes.map((val, index) => (
        <Route
          key={index}
          exact
          path={val?.path}
          element={
            !val?.isPrivate ? (
              val?.element
            ) : token ? (
              val?.element
            ) : (
              <Navigate to={"/"} replace />
            )
          }
        />
      ))}
    </Routes>
  );
};

export default AppRoutes;
